import { render, staticRenderFns } from "./FairInfo.vue?vue&type=template&id=86dee398&scoped=true&"
import script from "./FairInfo.vue?vue&type=script&lang=js&"
export * from "./FairInfo.vue?vue&type=script&lang=js&"
import style0 from "./FairInfo.vue?vue&type=style&index=0&id=86dee398&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86dee398",
  null
  
)

export default component.exports